import {Field} from 'formik';

import {
    FormikDateTimePicker,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Box} from "@mantine/core";
import {MetersAutocomplete} from "../../meters/inputs/MetersAutocomplete.tsx";
import {FormikList} from "../../../components/FormikList";
import {MeterDimensionsDropdown} from "../../meters/inputs/MeterDimensionsDropdown.tsx";
import {MeterReading} from "../types.ts";
import {CustomersAutocomplete} from "../../customers/inputs/CustomersAutocomplete.tsx";


export const FormComponent = ({values}: { values: MeterReading }) => {

    return (
        <Box>
            <PlatformFieldset legend={'Meter Reading'}>
                <Field
                    name='customerId'
                    label='Customer'
                    description='Please select the customer'
                    component={CustomersAutocomplete}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='meterId'
                    label='Meter'
                    description='Please select the meter'
                    component={MetersAutocomplete}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='meterValue'
                    label='Meter Value'
                    description='Please enter the meter value'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='timestamp'
                    label='Timestamp'
                    description='Please enter the timestamp'
                    component={FormikDateTimePicker}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>

            {values.meterId ?
                <PlatformFieldset legend={'Meter Dimensions'}>
                    <Field
                        name='dimensions'
                        label='Dimensions'
                        description='Please enter the dimensions'
                        getRowElements={() => [{
                            name: 'apiKey',
                            placeholder: 'API Key',
                            component: MeterDimensionsDropdown,
                            meterId: values.meterId
                        }, {
                            name: 'value',
                            placeholder: 'Value',
                            component: FormikTextInput
                        }]}
                        component={FormikList}
                    /></PlatformFieldset> : null}

        </Box>
    );
};
